import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const VideoWrapper = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: 24px;
  z-index: 0;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${props => props.isHovered ? 1 : 0};
  transition: opacity 0.3s ease;
`;

const WorkerVideo = ({ src, poster, muted, playsInline, loop, isHovered }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (isHovered) {
        videoRef.current.loop = true;
        videoRef.current.play().catch(err => console.log('Video autoplay failed:', err));
      } else {
        videoRef.current.loop = false;
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }, [isHovered]);

  return (
    <VideoWrapper>
      <StyledVideo
        ref={videoRef}
        src={src}
        poster={poster}
        muted={muted}
        playsInline={playsInline}
        loop={loop}
        isHovered={isHovered}
      />
    </VideoWrapper>
  );
};

export default WorkerVideo; 